<template>
  <div class="logo-globo-text-content" id="identidade-visual-logo-aplicacoes" data-search-anchor>
    <div class="title-globo-text-wrapper">
      <h1 class="logo-globo-text-title-span">{{ logoGloboTextTitleSpan }}</h1>
      <h1 class="logo-globo-text-title">{{ logoGloboTextTitle }}</h1>
    </div>
    <div class="description-globo-text-wrapper">
      <p class="logo-globo-text-description">{{ logoGloboTextDescription }}</p>

      <div>
        <div class="logo-globo-icon-wrapper">
          <IconCheck />
          <p class="logo-globo-text-description1">{{ logoGloboTextDescription1 }}</p>
        </div>

        <div class="logo-globo-icon-wrapper">
          <IconCancel />
          <p class="logo-globo-text-description2">{{ logoGloboTextDescription2 }}</p>
        </div>
      </div>
    </div>
    
    <div
      class="logo-globo-text-card-item"
      :style="{ backgroundImage: `url(${logoGloboTextImageSrc})` }"
    ></div>

    <div class="title-globo-text-wrapper">
      <h1 class="logo-globo-text-title-span">{{ logoGloboAplicacaoTitleSpan }}</h1>
      <h1 class="logo-globo-text-title">{{ logoGloboAplicacaoTitle }}</h1>
    </div>
    <div
      class="logo-globo-text-card-item2"
      :style="{ backgroundImage: `url(${logoGloboTextImageBottomSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class LogoGloboTextSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoGloboTextTitleSpan(): string {
    return this.getElementTitle(11, 0)
  }

  get logoGloboTextTitle(): string {
    return this.getElementText(11, 0)
  }

  get logoGloboTextDescription(): string {
    return this.getElementText(11, 1)
  }

  get logoGloboTextDescription1(): string {
    return this.getElementText(11, 2)
  }

  get logoGloboTextDescription2(): string {
    return this.getElementText(11, 3)
  }

  get logoGloboTextImageSrc(): string {
    return this.getElementMedia(11, 4)
  }

  get logoGloboTextImageBottomSrc(): string {
    return this.getElementMedia(11, 5)
  }

  get logoGloboAplicacaoTitleSpan(): string {
    return this.getElementTitle(11, 5)
  }

  get logoGloboAplicacaoTitle(): string {
    return this.getElementText(11, 5)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-globo-text-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-globo-text-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-globo-text-title-span {
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}
.logo-globo-text-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-globo-text-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 51.2% 48.8%;   
}

.logo-globo-icon-wrapper{
  display: flex;
  align-items: center;    
}

.logo-globo-text-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 378px;  
}

.logo-globo-text-description1,
.logo-globo-text-description2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;
  width: 378px; 
}

.title-image {
  font-size: 20px;
  font-weight: 600;
  text-align: left;

  padding-left: 3rem;
  width: 187px;
}

.logo-globo-text-card-item {
  position: relative;
  bottom: 0;
  width: 100%;
  max-width: 1032px;
  height: 705px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.logo-globo-text-card-item2 {
  position: relative;
  bottom: 0;
  width: 100%;
  max-width: 1032px;
  height: 522px;    
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-globo-text-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;

  margin: 0rem 0rem 3rem 0rem;
}
</style>
